import {Form, Input, Modal, Select, Spin} from 'antd';
import PropTypes from 'prop-types';
import {useEffect} from 'react';
import toast from 'react-hot-toast';
import {useSelector} from 'react-redux';

import {
  RQBrandRegistrationAPI, RQUpdateBrandAPI} from '../../../../../src/reactQuery/apis/rqgetProductBrand';
import {selectAuth} from '../../../../../src/redux/selectors/authSelector';

const {Option} = Select;

const BrandModal = ({open, onCancel, refetch, updateBrandData}) => {
  const [form] = Form.useForm();

  const auth = useSelector(selectAuth);
  const token = auth?.tokenData;

  const {mutate: registerBrand, isLoading: isCreating} =
    RQBrandRegistrationAPI({
      onSuccess: () => {
        toast.success('Brand added successfully');
        refetch();
        form.resetFields();
        onCancel();
      },
      onError: error => {
        const errorMessage =
    error?.response?.data?.message ||   
    error?.data?.message ||             
    error?.message ||                   
    'Failed to add Brand';

        toast.error(errorMessage);
      },
    });

  const {mutate: updateBrandAPI, isLoading: isUpdating} =
    RQUpdateBrandAPI({
      onSuccess: () => {
        toast.success('Brand updated successfully');
        refetch();
        form.resetFields();
        onCancel();
      },
      onError: error => {
        const errorMessage =
    error?.response?.data?.message ||   
    error?.data?.message ||             
    error?.message ||                   
    'Failed to add Brand';

        toast.error(errorMessage);
      },
    });

  useEffect(() => {
    if (updateBrandData) {
      form.setFieldsValue({
        name: updateBrandData.name,
        isActive: updateBrandData.isActive,
      });
    } else {
      form.resetFields();
    }
  }, [updateBrandData, form]);

  const handleFinish = values => {
    const payload = {
      name: values.name,
      isActive: values.isActive,
    };

    if (updateBrandData) {
      updateBrandAPI({
        token,
        id: updateBrandData.id,
        formData: payload,
      });
    } else {
      registerBrand({
        token,
        formData: payload,
      });
    }
  };

  const loading = isCreating || isUpdating;

  return (
    <Modal
      title={updateBrandData ? 'Update Brand' : 'Add New Brand'}
      open={open}
      width={600}
      centered
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => form.submit()}
      okText={updateBrandData ? 'Update' : 'Save'}
      cancelText={'Cancel'}
      okButtonProps={{
        loading,
        className: '!bg-primary-900 !text-white hover:!bg-primary-800',
      }}
    >
      <Form
        form={form}
        layout={'vertical'}
        onFinish={handleFinish}
      >
        <Form.Item
          label={'Brand Name'}
          name={'name'}
          getValueFromEvent={e => e.target.value.toUpperCase()} 
          rules={[
            {required: true, message: 'Please enter brand name'},
          ]}
        >
          <Input placeholder={'Enter brand name'} />
        </Form.Item>

        <Form.Item
          label={'Status'}
          name={'isActive'}
          rules={[
            {required: true, message: 'Please select status'},
          ]}
        >
          <Select placeholder={'Select status'}>
            <Option value={true}>Active</Option>
            <Option value={false}>Inactive</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

BrandModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
  updateBrandData: PropTypes.object,
};

export default BrandModal;
